jQuery(function ($) {

    $(document).ready(function() {
        initStats();
        initGraphsPlay();
        initScrollto();
        initFancybox();
        initOwlCarousel();
        initAutoRotatingText();
        initTabs();
        initLozad();
        initGraphs();
        initGraphsResize();
        initAthletesCarousel();
        initProductFeatures();
        //initConsultationVideo();
    });

    $(window).on( "resize", function() {
      initGraphsResize();
      initAthletesCarousel();
      initProductFeatures();
    });

    function initLozad(){
        const observer = lozad('.lozad');
        observer.observe();
    }

    function initTabs(){
        if($('#tabs').get(0)){
            $('#tabs').tabs();
        }
    }

    function initAutoRotatingText(){
        if($('.rotating-text').get(0)){
            $('.rotating-text').atrotating();
        }
    }

    function initConsultationVideo(){
        if($('#consultation-video').get(0)){
            let consultation_video = document.getElementById('#consultation-video');
            consultation_video.play();
        }
    }

    function initAthletesCarousel(){
        if($('.athletes-landing .owl-carousel').get(0)){
            var window_width = $(window).width();
            if (window_width < 768){
                $('.athletes-landing .owl-carousel').owlCarousel({
                  center: false,
                  items: 1,
                  loop:true,
                  margin:0,
                  autoWidth:true,
                  nav: false,
                  autoplay: true,
                  autoplayTimeout: 5000,
                  autoplayHoverPause: true,
                  responsive:{
                      600:{
                          items: 4
                      }
                  }
                });
            }
            else{
                $('.athletes-landing .owl-carousel').owlCarousel('destroy');
            }
        }
    }

    function initOwlCarousel(){
        if($('.testimonials-landing .owl-carousel').get(0)){
            $('.testimonials-landing .owl-carousel').owlCarousel({
              center: true,
              items: 1,
              loop:true,
              margin:40,
              autoWidth:true,
              nav: true,
              autoplay: true,
              autoplayTimeout: 5000,
              autoplayHoverPause: true,
              responsive:{
                  600:{
                      items: 3
                  }
              }
            });
        }
        if($('.testimonials-carousel .owl-carousel').get(0)){
            $('.testimonials-carousel .owl-carousel').owlCarousel({
              center: true,
              items:2,
              loop:true,
              margin:40,
              autoWidth:true,
              nav: true,
              autoplay: true,
              autoplayTimeout: 5000,
              autoplayHoverPause: true,
              responsive:{
                  600:{
                      items:4
                  }
              }
            });
        }
        if($('.partnerships-carousel .owl-carousel').get(0)){
            $('.partnerships-carousel .owl-carousel').owlCarousel({
              items: 1,
              loop: false,
              margin: 20,
              nav: true,
              autoWidth: true,
              responsive:{
                  678:{
                      autoWidth: false,
                      items: 2
                  }
              }
            });
        }
        if($('.testimonials-blocks').get(0)){
            $(".testimonials-blocks.group-3 .owl-carousel").owlCarousel({
              center: true,
              items:1,
              loop:true,
              margin: 30,
              autoWidth:true,
              nav: true,
              autoplay: true,
              autoplayTimeout: 9000,
              autoplayHoverPause: true,
              responsive:{
                  768:{
                      items: 3,
                      margin: 50
                  },
                  1280:{
                    items: 3,
                    margin: 100
                  }
              }
            });
            $(".testimonials-blocks.group-2 .owl-carousel").owlCarousel({
              center: true,
              items:1,
              loop:true,
              margin: 30,
              autoWidth:true,
              nav: true,
              autoplay: true,
              autoplayTimeout: 9000,
              autoplayHoverPause: true,
              responsive:{
                  768:{
                      center: false,
                      items: 2,
                      margin: 75
                  },
                  1280:{
                    center: false,
                    items: 2,
                    margin: 100
                  }
              }
            });
            $(".testimonials-blocks.single .owl-carousel").owlCarousel({
              center: true,
              items:1,
              loop:true,
              margin: 30,
              autoWidth:true,
              nav: true,
              autoplay: true,
              autoplayTimeout: 8000,
              autoplayHoverPause: true
            });
        }
    }

    function initFancybox(){
      Fancybox.bind('[data-fancybox]', {
        // Your custom options
      });
    }
  
    function initStats(){
        if($('.shopify-section[id*=efe04e5e-7d65-4046-8803-8174149955fb]').get(0) || $('.shopify-section[id*=7564b86c-6851-43a1-8652-0dcd1d9f3a76]').get(0)){
            $('.shopify-section[id*=efe04e5e-7d65-4046-8803-8174149955fb] .rich-text__title,.shopify-section[id*=7564b86c-6851-43a1-8652-0dcd1d9f3a76] .rich-text__title').each(function(index){
                let text = $(this).text().split('|');
                if(text[1] !== null){
                    text[0] = '<span class="counter">' + text[0] + '</span>';
                    text[1] = '<span class="text">' + text[1].replace("/", "<br>") + '</span>';
                    if(text[1] == '<span class="text"></span>'){
                        $(this).html('<span class="full-width">'+text[0]+'</span>');
                    }
                    else{
                        $(this).html(text[0]+text[1]);
                    }
                }
            });

            let counterUp = window.counterUp['default'];

            let $counters = $('.counter');

            $counters.each(function (ignore, counter) {
                let waypoint = new Waypoint( {
                    element: $(this),
                    handler: function() { 
                        $('.shopify-section[id*=efe04e5e-7d65-4046-8803-8174149955fb] .rich-text__title,.shopify-section[id*=7564b86c-6851-43a1-8652-0dcd1d9f3a76] .rich-text__title').css('visibility','visible');
                        counterUp(counter, {
                            duration: 500,
                            delay: 16
                        }); 
                        this.destroy();
                    },
                    offset: 'bottom-in-view',
                } );
            });
        }
    }

    function initScrollto(){
        if($('.shopify-section[id*=61ea087c-e250-4c0e-9129-17dd367dc3e0]').get(0)){
            $('.shopify-section[id*=61ea087c-e250-4c0e-9129-17dd367dc3e0] a.feature-link').on( "click", function(e) {
              e.preventDefault();
              let target = $(this).attr('href');
              $('html, body').animate({scrollTop: $(target).offset().top -100 }, 'slow');
            });
        }
        if($('.shopify-section .banner-landing').get(0)){
            $('.shopify-section .banner-landing a.button').on( "click", function(e) {
              let target = $(this).attr('href');
              if (target.indexOf("#") >= 0){
                e.preventDefault();
                $('html, body').animate({scrollTop: $(target).offset().top -150 }, 'slow');
              }
            });
        }
    }

    function initGraphs(){
        if($('.graph-filters').length){
            $('.graph-filters button').on('click', function(e){
                e.preventDefault();
                let target = $(this).attr('data-target');
                if($(this).hasClass('active')){
                    $(this).removeClass('active');
                    $('.blend-wrapper[data-blend='+target+']').removeClass('active');
                }
                else{
                    $(this).addClass('active')
                    $('.blend-wrapper[data-blend='+target+']').addClass('active');
                }
            });
        }
    }

    function initGraphsPlay(){
        if($('.graph-filters').length){
            let $graph_filters = $('.graph-filters');
            $graph_filters.each(function (index) { 
                let graph_filters_waypoint = new Waypoint( {
                    element: $(this),
                    handler: function() { 
                        setTimeout(function() { 
                            $('.graph-filters .btn.tactical').removeClass('active').addClass('active');
                            $('.blend-wrapper[data-blend="tactical"]').removeClass('active').addClass('active');
                        }, 200);
                        setTimeout(function() { 
                            $('.graph-filters .btn.performance').removeClass('active').addClass('active');
                            $('.blend-wrapper[data-blend="performance"]').removeClass('active').addClass('active');
                        }, 1200);
                        setTimeout(function() { 
                            $('.graph-filters .btn.gold').removeClass('active').addClass('active');
                            $('.blend-wrapper[data-blend="gold"]').removeClass('active').addClass('active');
                        }, 2200);
                        setTimeout(function() { 
                            $('.graph-filters .btn.health').removeClass('active').addClass('active');
                            $('.blend-wrapper[data-blend="health"]').removeClass('active').addClass('active');
                        }, 3200);
                        this.destroy();
                    },
                    offset: 'bottom-in-view',
                });
            });
        }
    }

    function initGraphsResize(){
        if($('.pdp-graph').length){
            let graphWidth = parseInt($('.pdp-graph').width());
            let goldWidth = parseInt(graphWidth*1.1)+'px';
            let healthWidth = parseInt(graphWidth*1.1)+'px';
            let performanceWidth = parseInt(graphWidth*1.09)+'px';
            let tacticalWidth = parseInt(graphWidth*1.16)+'px';
            $('#blend-gold').width(goldWidth);
            $('#blend-health').width(healthWidth);
            $('#blend-performance').width(performanceWidth);
            $('#blend-tactical').width(tacticalWidth);
        }
    }

    function initProductFeatures(){
        if($('.product-options-landing').get(0)){

            var window_width = $(window).width();
            if (window_width < 768){
                $('.product-options-landing .owl-carousel').owlCarousel({
                  center: true,
                  items: 1,
                  loop:true,
                  margin:20,
                  autoWidth:true,
                  nav: false,
                  autoplay: true,
                  autoplayTimeout: 5000,
                  autoplayHoverPause: true,
                  responsive:{
                      600:{
                          items: 3
                      }
                  }
                });
            }
            else{
                $('.product-options-landing .owl-carousel').owlCarousel('destroy');
                let $features = $('.product-options-landing');
                if(!$('.product-options-landing .product-options__items .product-options__item').hasClass('active')){
                    $features.each(function (index) {
                        let waypoint = new Waypoint( {
                            element: $(this),
                            handler: function() { 
                                $('.product-options-landing .product-options__items .product-options__item').each(function (index) { 
                                    var item = index+1;
                                    var timeout = (item)*300;
                                    setTimeout(() => {
                                      $('.product-options-landing .product-options__items .product-options__item:nth-child('+item+')').addClass('active');
                                    }, timeout);
                                });
                                this.destroy();
                            },
                            offset: '100%',
                        } );
                    });
                }
            }

        }
    }

}); // jQuery End
